import { useGetCountriesList } from '@common/slices/drawer.slice';
import { lookupListAsRecordObject } from '@utils/graph-utils';

import { useGetTravelLovs } from '../proposal.slice';

export function useTravelLovs(planID: string) {
  const { data } = useGetTravelLovs({
    variables: { planID },
    skip: !planID,
    fetchPolicy: 'cache-and-network'
  });
  const { data: countriesData } = useGetCountriesList();
  const departure = lookupListAsRecordObject(
    countriesData?.core?.getCountries
  );
  const destination = lookupListAsRecordObject(
    data?.planConfig?.getDestinationsLookup
  );

  const covers: Record<string, string> = {};
  const items = data?.planConfig?.getPolicyTravelCovers.items ?? [];
  for (const it of items) {
    const id = it?.id;
    if (!id) continue;
    const label = [it?.code, it?.name].filter(Boolean).join(' - ');
    covers[id] = label || id;
  }

  return { departure, destination, covers };
}
